import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as entry from '../entry'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: entry.RESOURCE.payload.dimension.partialId,
      partialId: entry.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Used to group/aggregate Exclusion amounts together. Primarily used for the Reclassification & Adjustment report in Rate',
    isOptional: true,
    name: 'Exclusion Group',
    partialId: PartialId.Standard.create('excl'),
    type: core.common.value.types.Intrinsic.Text, // TODO: maybe an enum?
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
